import React from 'react';
import { User } from '@tassomutuo-backoffice/types';
import { Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportIcon from '@mui/icons-material/Report';

interface IProps {
  user: User;
}

const TeamUserBqIntegrityStatus = ({ user }: IProps) => {
  const isConsistent = user.bqIntegrityCheck?.isConsistent;

  if (!isConsistent) {
    const discrepancies = user.bqIntegrityCheck?.discrepancies || [];

    return (
      <Tooltip
        title={
          <div>
            {discrepancies.length > 0
              ? discrepancies.map((d, index) => (
                  <div key={index}>
                    {d.field}: {d.issue}
                  </div>
                ))
              : 'Dato NON consistente'}
          </div>
        }
      >
        <ReportIcon color="error" />
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Dato consistente">
      <CheckCircleIcon color="success" />
    </Tooltip>
  );
};

export default TeamUserBqIntegrityStatus;
